import React from 'react'
import PropTypes from 'prop-types'
import { intl } from 'lang/intl'

const FlagComponent = ({ countryCode }) => (
  <img
    className="flag-component"
    src={`/resources/um/graphics/flags/${countryCode.toLowerCase()}.gif`}
    alt={intl.formatMessage(
      { defaultMessage: 'flag for country with code {countryCode}' },
      { countryCode }
    )}
  />
)

FlagComponent.propTypes = {
  countryCode: PropTypes.string.isRequired,
}

export default FlagComponent
